// Navartha — full approved bilingual copy (EN source, natural ID translation).
// Every leaf is { en, id }.

export const T = {
  nav: {
    howWeWork: { en: 'How We Work', id: 'Cara Kami Bekerja' },
    whereValue: { en: 'Where We Create Value', id: 'Di Mana Kami Menciptakan Nilai' },
    about: { en: 'About Navartha', id: 'Tentang Navartha' },
    clinic: { en: 'Business Clinic', id: 'Business Clinic' },
    cta: { en: 'Start a Business Clinic', id: 'Mulai Business Clinic' },
    menu: { en: 'Menu', id: 'Menu' },
    close: { en: 'Close', id: 'Tutup' },
  },

  hero: {
    index: '01',
    eyebrow: { en: 'AI Transformation & Implementation Firm', id: 'AI Transformation & Implementation Firm' },
    headlineLines: {
      en: ['Understand', 'where change', 'creates value.'],
      id: ['Pahami di mana', 'perubahan', 'menciptakan nilai.'],
    },
    body: {
      en: 'Navartha helps companies identify high-value problems and opportunities, redesign how work gets done, and implement the right AI and technology for measurable business outcomes.',
      id: 'Navartha membantu perusahaan mengidentifikasi masalah dan peluang bernilai tinggi, merancang ulang cara kerja, dan mengimplementasikan AI serta teknologi yang tepat untuk hasil bisnis yang terukur.',
    },
    ctaPrimary: { en: 'Start a Business Clinic', id: 'Mulai Business Clinic' },
    ctaSecondary: { en: 'See How We Work', id: 'Lihat Cara Kami Bekerja' },
    supporting: {
      en: ['Diagnose', 'Design', 'Implement', 'Measure'],
      id: ['Diagnosis', 'Desain', 'Implementasi', 'Ukur'],
    },
  },

  pov: {
    index: '02',
    eyebrow: { en: 'Our Point of View', id: 'Sudut Pandang Kami' },
    headline: {
      en: "We don't start with AI.\nWe start with understanding.",
      id: 'Kami tidak mulai dari AI.\nKami mulai dari pemahaman.',
    },
    body1: {
      en: 'Technology only matters when it improves something that matters.',
      id: 'Teknologi hanya penting jika ia memperbaiki hal yang benar-benar penting.',
    },
    body2: {
      en: 'Before deciding what to automate, build, or change, we study the work itself: the workflow, friction, economics, constraints, people, and desired outcome.',
      id: 'Sebelum memutuskan apa yang diotomasi, dibangun, atau diubah, kami melihat pekerjaannya terlebih dahulu: alur kerja, friksi, ekonomi, keterbatasan, manusia, dan hasil yang diinginkan.',
    },
    body3: {
      en: 'Then we determine where technology can create value.',
      id: 'Dari situ kami menentukan di mana teknologi dapat menciptakan nilai.',
    },
    chain: {
      en: [
        { label: 'Problem', q: 'What is true / happening?' },
        { label: 'Workflow', q: 'How does work operate?' },
        { label: 'Intervention', q: 'What should change?' },
        { label: 'Outcome', q: 'What becomes better?' },
      ],
      id: [
        { label: 'Masalah', q: 'Apa yang sebenarnya terjadi?' },
        { label: 'Alur Kerja', q: 'Bagaimana pekerjaan berjalan?' },
        { label: 'Intervensi', q: 'Apa yang perlu berubah?' },
        { label: 'Hasil', q: 'Apa yang menjadi lebih baik?' },
      ],
    },
    supporting: {
      en: 'The technology comes after the problem is understood.',
      id: 'Teknologi datang setelah masalahnya dipahami.',
    },
  },

  outcomes: {
    index: '03',
    eyebrow: { en: 'What Change Should Create', id: 'Tujuan Setiap Perubahan' },
    headline: {
      en: 'Change should create business value.',
      id: 'Perubahan harus menciptakan nilai bisnis.',
    },
    intro: {
      en: 'We evaluate opportunities through three outcome lenses.',
      id: 'Kami menilai peluang melalui tiga lensa hasil.',
    },
    items: {
      en: [
        { title: 'GROW', desc: 'Increase the capacity to create or capture value.', list: ['Revenue capacity', 'Acquisition', 'Conversion', 'Customer value', 'Commercial throughput'] },        { title: 'OPTIMIZE', desc: 'Improve how existing work performs.', list: ['Speed', 'Quality', 'Utilization', 'Economics', 'Consistency', 'Throughput'] },
        { title: 'SIMPLIFY', desc: 'Reduce unnecessary complexity.', list: ['Manual work', 'Fragmentation', 'Repetitive coordination', 'Operational friction'] },
      ],
      id: [
        { title: 'TUMBUH', desc: 'Memperbesar kapasitas untuk menciptakan atau menangkap nilai.', list: ['Kapasitas pendapatan', 'Akuisisi', 'Konversi', 'Nilai pelanggan', 'Throughput komersial'] },
        { title: 'OPTIMALKAN', desc: 'Memperbaiki kinerja pekerjaan yang sudah ada.', list: ['Kecepatan', 'Kualitas', 'Utilisasi', 'Ekonomi', 'Konsistensi', 'Throughput'] },
        { title: 'SEDERHANAKAN', desc: 'Mengurangi kompleksitas yang tidak perlu.', list: ['Kerja manual', 'Fragmentasi', 'Koordinasi berulang', 'Friksi operasional'] },
      ],
    },
    closing: {
      en: ['Not every problem needs more technology.', 'Every intervention should have a reason to exist.'],
      id: ['Tidak semua masalah membutuhkan lebih banyak teknologi.', 'Setiap intervensi harus punya alasan untuk hadir.'],
    },
    listLabel: { en: 'Involves', id: 'Melibatkan' },
  },

  value: {
    index: '04',
    eyebrow: { en: 'Where We Create Value', id: 'Di Mana Kami Menciptakan Nilai' },
    headline: {
      en: 'From business friction\nto better workflows.',
      id: 'Dari friksi bisnis\nmenjadi alur kerja yang lebih baik.',
    },
    intro: {
      en: 'Navartha looks for places where better systems, workflow redesign, automation, or AI can clearly improve how a company operates.',
      id: 'Navartha mencari titik-titik di mana sistem yang lebih baik, penataan ulang alur kerja, otomasi, atau AI dapat memberi perbaikan nyata pada cara perusahaan beroperasi.',
    },
    labels: {
      friction: { en: 'The friction', id: 'Friksi saat ini' },
      change: { en: 'What may change', id: 'Kemungkinan perubahan' },
      outcome: { en: 'Potential outcome', id: 'Hasil potensial' },
    },
    areas: {
      en: [
        { num: '01', title: 'Sales & Lead Operations', friction: 'Research, qualification, outreach, and follow-up depend heavily on manual effort, making execution inconsistent and opportunities easier to miss.', change: 'Research workflows, qualification, follow-up, handoffs, pipeline visibility.', outcome: 'More consistent execution with less repetitive work.' },
        { num: '02', title: 'Marketing & Content Operations', friction: 'Teams repeatedly spend time researching, drafting, repurposing, reviewing, and coordinating content across different tools and people.', change: 'Research → production → review → reuse → distribution.', outcome: 'Higher throughput and more consistent execution.' },
        { num: '03', title: 'Client & Delivery Operations', friction: 'Project information is fragmented across messages, documents, spreadsheets, and individual memory.', change: 'Handoffs, reporting, status visibility, repetitive coordination, workflow support.', outcome: 'Clearer operations with less coordination friction.' },
        { num: '04', title: 'Internal Knowledge & Repetitive Work', friction: 'People repeatedly search for, request, or recreate information that already exists somewhere in the organization.', change: 'Knowledge access, recurring administrative workflows, internal decision support.', outcome: 'Faster access to information and less repetitive work.' },
      ],
      id: [
        { num: '01', title: 'Penjualan & Operasi Lead', friction: 'Riset, kualifikasi, outreach, dan tindak lanjut masih sangat bergantung pada kerja manual, eksekusi menjadi tidak konsisten dan peluang mudah terlewat.', change: 'Alur riset, kualifikasi, tindak lanjut, serah terima, visibilitas pipeline.', outcome: 'Eksekusi lebih konsisten dengan pekerjaan berulang yang lebih sedikit.' },
        { num: '02', title: 'Pemasaran & Operasi Konten', friction: 'Tim berulang kali menghabiskan waktu untuk riset, penulisan, penyesuaian, review, dan koordinasi konten di berbagai tools dan dengan banyak orang.', change: 'Riset → produksi → review → pemakaian ulang → distribusi.', outcome: 'Throughput lebih tinggi dan eksekusi yang lebih konsisten.' },
        { num: '03', title: 'Operasi Klien & Delivery', friction: 'Informasi proyek tersebar di pesan, dokumen, spreadsheet, dan ingatan masing-masing orang.', change: 'Serah terima, pelaporan, visibilitas status, koordinasi berulang, dukungan alur kerja.', outcome: 'Operasi yang lebih tertata dengan friksi koordinasi yang lebih rendah.' },
        { num: '04', title: 'Pengetahuan Internal & Pekerjaan Berulang', friction: 'Orang berulang kali mencari, meminta, atau membuat ulang informasi yang sebenarnya sudah ada di suatu tempat dalam organisasi.', change: 'Akses pengetahuan, alur kerja administratif berulang, dukungan keputusan internal.', outcome: 'Akses informasi lebih cepat dan pekerjaan berulang yang lebih sedikit.' },
      ],
    },
    invite: {
      heading: {
        en: 'A different business challenge?',
        id: 'Kebutuhan Anda berbeda?',
      },
      body: {
        en: 'These four areas are examples of where we work. Tell us about your business challenge. We will assess the workflow, the opportunity for improvement, and whether Navartha is the right fit.',
        id: 'Empat area ini adalah contoh, bukan batasan layanan kami. Ceritakan tantangan bisnis Anda. Kami akan menelaah kebutuhan, alur kerja, dan kemungkinan perbaikannya sebelum menentukan apakah Navartha dapat membantu.',
      },
      cta: {
        en: 'Tell Us What You Need',
        id: 'Ceritakan Kebutuhan Anda',
      },
    },
  },

  marquee: {
    words: {
      en: ['Diagnose', 'Design', 'Implement', 'Measure'],
      id: ['Diagnosis', 'Desain', 'Implementasi', 'Ukur'],
    },
    tag: { en: 'Understand before you automate', id: 'Pahami dulu, baru otomasi' },
  },

  how: {
    index: '05',
    eyebrow: { en: 'How We Work', id: 'Cara Kami Bekerja' },
    headline: {
      en: 'Understand first.\nThen change what matters.',
      id: 'Pahami dulu.\nLalu ubah yang penting.',
    },
    intro: {
      en: 'Navartha follows a simple operating method from diagnosis to measurable change.',
      id: 'Navartha mengikuti metode operasional sederhana, dari diagnosis hingga perubahan yang terukur.',
    },
    examines: { en: 'We examine:', id: 'Kami menelaah:' },
    compare: { en: 'We compare:', id: 'Kami membandingkan:' },
    decide: { en: 'and decide what should be refined, scaled, or stopped.', id: 'lalu memutuskan apa yang diperbaiki, diperluas, atau dihentikan.' },
    steps: {
      en: [
        { num: '01', title: 'Diagnose', lead: 'Understand the work before choosing the technology.', body: '', list: ['current workflow', 'friction', 'constraints', 'stakeholders', 'economic impact', 'desired outcome'], listLabel: 'examines', micro: ['Current state', 'Friction', 'Impact'] },
        { num: '02', title: 'Design', lead: 'Define what should change, and what should not.', body: 'We redesign the workflow and determine the simplest effective role for:', list: ['people', 'AI', 'automation', 'existing technology'], listLabel: 'body', micro: ['Opportunity', 'Intervention', 'Future state'] },
        { num: '03', title: 'Implement', lead: 'Turn the design into working change.', body: 'We configure, integrate, or build the required solution and introduce the redesigned workflow with appropriate human oversight.', list: [], listLabel: 'body', micro: ['Design', 'Working system'] },
        { num: '04', title: 'Measure', lead: 'Determine whether the change actually created value.', body: '', list: ['baseline', 'new state', 'evidence', 'learning'], listLabel: 'compare', micro: ['Baseline', 'Change', 'Evidence', 'Learning'] },
      ],
      id: [
        { num: '01', title: 'Diagnosis', lead: 'Memahami pekerjaan sebelum memilih teknologi.', body: '', list: ['alur kerja saat ini', 'friksi', 'keterbatasan', 'pemangku kepentingan', 'dampak ekonomi', 'hasil yang diinginkan'], listLabel: 'examines', micro: ['Kondisi saat ini', 'Friksi', 'Dampak'] },
        { num: '02', title: 'Desain', lead: 'Menetapkan apa yang harus berubah, dan apa yang tidak.', body: 'Kami merancang ulang alur kerja dan menentukan peran paling sederhana yang efektif untuk:', list: ['manusia', 'AI', 'otomasi', 'teknologi yang sudah ada'], listLabel: 'body', micro: ['Peluang', 'Intervensi', 'Kondisi ke depan'] },
        { num: '03', title: 'Implementasi', lead: 'Mengubah desain menjadi perubahan yang benar-benar berjalan.', body: 'Kami mengonfigurasi, mengintegrasikan, atau membangun solusi yang dibutuhkan, lalu memperkenalkan alur kerja baru dengan pengawasan manusia yang tepat.', list: [], listLabel: 'body', micro: ['Desain', 'Sistem yang berjalan'] },
        { num: '04', title: 'Ukur', lead: 'Memastikan perubahan benar-benar menciptakan nilai.', body: '', list: ['baseline', 'kondisi baru', 'bukti', 'pembelajaran'], listLabel: 'compare', micro: ['Baseline', 'Perubahan', 'Bukti', 'Pembelajaran'] },
      ],
    },
    closing: {
      en: ['Diagnose', 'Design', 'Implement', 'Measure'],
      id: ['Diagnosis', 'Desain', 'Implementasi', 'Ukur'],
    },
  },

  principles: {
    index: '06',
    eyebrow: { en: 'How We Make Decisions', id: 'Cara Kami Mengambil Keputusan' },
    headline: { en: 'Clarity before complexity.', id: 'Kejelasan sebelum kompleksitas.' },
    items: {
      en: [
        { title: 'Diagnose Before Automate', desc: 'Understand the work before prescribing technology.' },
        { title: 'Outcome Before Technology', desc: 'The business outcome determines the intervention.' },
        { title: 'Problem Before Solution', desc: 'Tools come after the problem is clear.' },
        { title: 'Simplest Effective Solution', desc: 'More technology is not automatically better.' },
        { title: 'Human + Technology', desc: 'Design the workflow around both.' },
        { title: 'Evidence Before Scale', desc: 'Measure before expanding what has not been proven.' },
      ],
      id: [
        { title: 'Diagnosis Sebelum Otomasi', desc: 'Pahami pekerjaannya sebelum meresepkan teknologi.' },
        { title: 'Hasil Sebelum Teknologi', desc: 'Hasil bisnis yang menentukan intervensinya.' },
        { title: 'Masalah Sebelum Solusi', desc: 'Tools datang setelah masalahnya jelas.' },
        { title: 'Solusi Sederhana yang Efektif', desc: 'Lebih banyak teknologi tidak otomatis lebih baik.' },
        { title: 'Manusia + Teknologi', desc: 'Rancang alur kerja dengan mempertimbangkan keduanya.' },
        { title: 'Bukti Sebelum Skala', desc: 'Ukur sebelum memperluas apa yang belum terbukti.' },
      ],
    },
    closing: {
      en: ['The objective is not to introduce more AI.', 'The objective is to make the work better.'],
      id: ['Tujuannya bukan memperkenalkan lebih banyak AI.', 'Tujuannya adalah membuat pekerjaan menjadi lebih baik.'],
    },
  },

  about: {
    index: '07',
    eyebrow: { en: 'About Navartha', id: 'Tentang Navartha' },
    headline: {
      en: 'Built around a simple belief: understand before you automate.',
      id: 'Dibangun di atas keyakinan sederhana: pahami dulu, baru otomasi.',
    },
    body1: {
      en: 'Navartha is an AI Transformation & Implementation firm focused on helping companies identify where change can create real business value.',
      id: 'Navartha adalah firma AI Transformation & Implementation yang berfokus membantu perusahaan mengidentifikasi di mana perubahan dapat menciptakan nilai bisnis yang nyata.',
    },
    combine: { en: 'We combine:', id: 'Kami memadukan:' },
    combineList: {
      en: ['business diagnosis', 'workflow design', 'practical implementation'],
      id: ['diagnosis bisnis', 'desain alur kerja', 'implementasi yang praktis'],
    },
    body2: {
      en: 'to improve how work gets done, using AI, automation, and technology where they make the system better.',
      id: 'untuk memperbaiki cara kerja, menggunakan AI, otomasi, dan teknologi di tempat yang membuat sistem lebih baik.',
    },
    approachLabel: { en: 'Our approach is deliberate:', id: 'Pendekatan kami terarah dan terukur:' },
    approachList: {
      en: ['understand the current state', 'identify what matters', 'implement the right intervention', 'measure what changes'],
      id: ['pahami kondisi saat ini', 'identifikasi apa yang penting', 'implementasikan intervensi yang tepat', 'ukur apa yang berubah'],
    },
    visual: {
      en: ['Diagnose', 'Design', 'Implement', 'Measure'],
      id: ['Diagnosis', 'Desain', 'Implementasi', 'Ukur'],
    },
  },

  approach: {
    index: '08',
    eyebrow: { en: 'How We Approach the Work', id: 'Cara Kami Mendekati Pekerjaan' },
    headline: { en: 'The solution should earn its complexity.', id: 'Kompleksitas solusi harus sepadan dengan manfaatnya.' },
    items: {
      en: [
        { title: 'Problem-led', desc: 'We begin with the business problem, not a predetermined technology.' },
        { title: 'Technology-agnostic', desc: 'The objective is the right intervention, not selling a specific tool.' },
        { title: 'Implementation-minded', desc: 'Recommendations should translate into working change.' },
        { title: 'Measurement-oriented', desc: 'Improvement should eventually be visible in evidence, not only presentation slides.' },
      ],
      id: [
        { title: 'Berbasis Masalah', desc: 'Kami mulai dari masalah bisnis, bukan dari teknologi yang sudah ditentukan.' },
        { title: 'Agnostik terhadap Teknologi', desc: 'Tujuannya adalah intervensi yang tepat, bukan menjual tool tertentu.' },
        { title: 'Berorientasi Implementasi', desc: 'Rekomendasi harus berubah menjadi perubahan yang berjalan.' },
        { title: 'Berorientasi Pengukuran', desc: 'Perbaikan pada akhirnya harus terlihat dalam bukti, bukan hanya di slide presentasi.' },
      ],
    },
    closing: {
      en: ['Understand.', 'Change.', 'Measure.'],
      id: ['Pahami.', 'Ubah.', 'Ukur.'],
    },
  },

  clinic: {
    index: '09',
    eyebrow: { en: 'Navartha Business Clinic', id: 'Navartha Business Clinic' },
    headline: { en: 'Start with the problem, not the tool.', id: 'Mulai dari masalahnya, bukan tool-nya.' },
    body: {
      en: 'The Business Clinic is an initial conversation to understand where change could create real value in your business.',
      id: 'Business Clinic adalah percakapan awal untuk memahami di mana perubahan dapat menciptakan nilai di bisnis Anda.',
    },
    body2: {
      en: 'You do not need to know which AI tool, automation, or solution is required.',
      id: 'Anda tidak perlu mengetahui tool AI, otomasi, atau solusi yang dibutuhkan.',
    },
    help: { en: 'Help us understand:', id: 'Bantu kami memahami:' },
    helpList: {
      en: ['what is happening today', 'where the friction exists', 'why it matters', 'what better would look like'],
      id: ['apa yang sedang terjadi', 'di mana friksinya', 'mengapa ini penting', "seperti apa 'lebih baik' itu"],
    },
    cta: { en: 'Start a Business Clinic', id: 'Mulai Business Clinic' },
    processLabel: { en: 'The clinic process', id: 'Proses Business Clinic' },
    process: {
      en: [
        { num: '01', title: 'Submit your context', desc: 'Tell us what is happening and what you are trying to improve.' },
        { num: '02', title: 'Navartha reviews it', desc: 'We assess whether there is a real problem or opportunity worth exploring.' },
        { num: '03', title: 'If there is a fit', desc: 'We invite you to a Business Clinic conversation.' },
        { num: '04', title: 'Diagnose before recommending', desc: 'We understand the situation before discussing an implementation path.' },
      ],
      id: [
        { num: '01', title: 'Kirim konteks Anda', desc: 'Ceritakan apa yang sedang terjadi dan apa yang ingin Anda perbaiki.' },
        { num: '02', title: 'Navartha meninjaunya', desc: 'Kami menilai apakah ada masalah atau peluang yang layak untuk dieksplorasi.' },
        { num: '03', title: 'Jika ada kesesuaian', desc: 'Kami mengundang Anda ke percakapan Business Clinic.' },
        { num: '04', title: 'Diagnosis sebelum rekomendasi', desc: 'Kami memahami situasinya sebelum membahas jalannya implementasi.' },
      ],
    },
    note: {
      en: 'We review each request to understand your needs and identify appropriate next steps.',
      id: 'Setiap permintaan kami tinjau untuk memahami kebutuhan dan menentukan langkah berikutnya yang sesuai.',
    },
  },

  finalCta: {
    eyebrow: { en: 'Start Here', id: 'Mulai Dari Sini' },
    headline: { en: 'Start with understanding.', id: 'Mulai dari pemahaman.' },
    bodyLead: { en: 'Tell us where the work feels:', id: 'Beri tahu kami di mana pekerjaan terasa:' },
    bodyWords: {
      en: ['slower', 'harder', 'more expensive', 'less effective'],
      id: ['lebih lambat', 'lebih sulit', 'lebih mahal', 'kurang efektif'],
    },
    bodyTail: { en: 'than it should be.', id: 'dari yang seharusnya.' },
    cta: { en: 'Start a Business Clinic', id: 'Mulai Business Clinic' },
    email: 'hello@navartha.id',
  },

  footer: {
    descriptor: { en: 'AI Transformation & Implementation Firm', id: 'AI Transformation & Implementation Firm' },
    copyright: { en: '© 2026 Navartha.', id: '© 2026 Navartha.' },
    tagline: { en: 'Understand before you automate.', id: 'Pahami dulu, baru otomasi.' },
  },

  clinicPage: {
    eyebrow: { en: 'Business Clinic', id: 'Business Clinic' },
    headline: {
      en: "Tell us where the work isn't working as well as it should.",
      id: 'Ceritakan di mana pekerjaan tidak berjalan sebaik yang seharusnya.',
    },
    body: {
      en: "You don't need to diagnose the solution yourself.",
      id: 'Anda tidak perlu mendiagnosis solusinya sendiri.',
    },
    body2: {
      en: 'Give us enough context to understand:',
      id: 'Beri kami konteks yang cukup untuk memahami:',
    },
    body2List: {
      en: ['what is happening', 'why it matters', 'what a better outcome could look like'],
      id: ['apa yang sedang terjadi', 'mengapa ini penting', 'seperti apa hasil yang lebih baik'],
    },
    micro: {
      en: ['Problem first.', 'Solution second.'],
      id: ['Masalah dulu.', 'Solusi belakangan.'],
    },
    understandTitle: { en: 'What we want to understand', id: 'Apa yang ingin kami pahami' },
    understandNote: {
      en: 'The initial review is about context, not technical specifications.',
      id: 'Tinjauan awal bersifat kontekstual, bukan spesifikasi teknis.',
    },
    understandList: {
      en: ['What your company is trying to achieve', 'Where the friction exists', 'How the workflow currently operates', 'What impact the problem creates', 'What a better outcome would look like', 'Important constraints or urgency'],
      id: ['Apa yang ingin dicapai perusahaan Anda', 'Di mana friksi berada', 'Bagaimana alur kerja ini berjalan saat ini', 'Dampak apa yang ditimbulkan masalah ini', 'Seperti apa hasil yang lebih baik', 'Kendala penting atau tingkat urgensi'],
    },
    formLabel: { en: 'Business Clinic request', id: 'Permintaan Business Clinic' },
  },

  form: {
    steps: {
      en: ['About You', 'Company', 'Situation'],
      id: ['Tentang Anda', 'Perusahaan', 'Situasi'],
    },
    stepWord: { en: 'Step', id: 'Langkah' },
    ofWord: { en: 'of', id: 'dari' },
    next: { en: 'Next', id: 'Lanjut' },
    back: { en: 'Back', id: 'Kembali' },
    submit: { en: 'Submit for Review', id: 'Kirim untuk Ditinjau' },
    submitting: { en: 'Submitting…', id: 'Sedang mengirim…' },
    errorBanner: {
      en: 'Something went wrong while submitting. Please try again.',
      id: 'Terjadi kesalahan saat mengirim. Silakan coba lagi.',
    },
    required: { en: 'This field is required.', id: 'Kolom ini wajib diisi.' },
    invalidEmail: { en: 'Please enter a valid work email.', id: 'Masukkan email kerja yang valid.' },
    minLength: { en: 'Please add a little more detail (at least 10 characters).', id: 'Mohon tambahkan sedikit detail lagi (minimal 10 karakter).' },
    rateLimited: { en: 'Too many submissions from this connection right now. Please try again later.', id: 'Terlalu banyak permintaan dari koneksi ini saat ini. Silakan coba lagi nanti.' },
    networkError: { en: 'The request could not reach us. Please check your connection and try again.', id: 'Permintaan tidak dapat terkirim. Periksa koneksi Anda dan coba lagi.' },
    consent: {
      en: 'I agree that Navartha may review this information and contact me to discuss appropriate next steps.',
      id: 'Saya setuju Navartha meninjau informasi ini dan menghubungi saya untuk membahas langkah berikutnya yang sesuai.',
    },
    nonGuarantee: {
      en: 'Submitting this form does not guarantee a Business Clinic invitation or an engagement.',
      id: 'Pengiriman formulir ini tidak menjamin undangan Business Clinic atau kerja sama dengan Navartha.',
    },
    securityTitle: { en: 'Before you write:', id: 'Sebelum menulis:' },
    security: {
      en: 'Please do not submit passwords, API keys, login credentials, confidential files, sensitive personal information, or production data through this form. General business and workflow information is sufficient for the initial Business Clinic review.',
      id: 'Mohon jangan kirim kata sandi, API key, kredensial login, file rahasia, data pribadi sensitif, atau data produksi melalui formulir ini. Informasi bisnis dan alur kerja umum sudah cukup untuk tinjauan awal Business Clinic.',
    },
    sizePlaceholder: { en: 'Select a range', id: 'Pilih rentang' },
    fields: {
      fullName: { label: { en: 'Full Name', id: 'Nama Lengkap' }, placeholder: { en: 'Your name', id: 'Nama Anda' }, required: true },
      email: { label: { en: 'Work Email', id: 'Email Kerja' }, placeholder: { en: 'you@company.com', id: 'nama@perusahaan.com' }, required: true },
      role: { label: { en: 'Role / Title', id: 'Jabatan / Posisi' }, placeholder: { en: 'e.g. Operations Manager, Head of Marketing', id: 'Contoh: Operations Manager, Head of Marketing' }, required: true },
      company: { label: { en: 'Company Name', id: 'Nama Perusahaan' }, placeholder: { en: 'Company name', id: 'Nama perusahaan' }, required: true },
      website: { label: { en: 'Company Website', id: 'Website Perusahaan' }, placeholder: { en: 'www.company.com', id: 'www.perusahaan.com' } },
      industry: { label: { en: 'Industry', id: 'Industri' }, placeholder: { en: 'e.g. logistics, retail, finance', id: 'Contoh: logistik, ritel, keuangan' } },
      size: { label: { en: 'Approximate Company Size', id: 'Perkiraan Ukuran Perusahaan' }, options: { en: ['1–9', '10–49', '50–199', '200–499', '500+'], id: ['1–9', '10–49', '50–199', '200–499', '500+'] } },
      improve: { label: { en: 'What are you trying to improve?', id: 'Apa yang ingin Anda perbaiki?' }, placeholder: { en: 'The situation you want to change…', id: 'Situasi yang ingin Anda ubah…' }, required: true },
      friction: { label: { en: 'Where does the current process feel inefficient, constrained, or difficult?', id: 'Di mana proses saat ini terasa tidak efisien, terhambat, atau sulit?' }, placeholder: { en: 'The main points of friction…', id: 'Titik friksi utama yang Anda rasakan…' }, required: true },
      workflow: { label: { en: 'How does this workflow currently work?', id: 'Bagaimana alur kerja ini berjalan saat ini?' }, placeholder: { en: 'Describe the current steps, tools, and people involved…', id: 'Gambarkan langkah, tools, dan orang yang terlibat saat ini…' }, required: true },
      impact: { label: { en: 'What impact does this problem have on the business?', id: 'Dampak apa yang ditimbulkan masalah ini pada bisnis?' }, placeholder: { en: 'Costs, time, quality, or missed opportunities…', id: 'Biaya, waktu, kualitas, atau peluang yang hilang…' }, required: true },
      better: { label: { en: 'What would a better outcome look like?', id: "Seperti apa hasil yang lebih baik menurut Anda?" }, placeholder: { en: 'A short picture of “better”…', id: 'Gambaran singkat tentang “lebih baik”…' }, required: true },
      urgency: { label: { en: 'How urgent is this?', id: 'Seberapa urgen hal ini?' }, options: { en: ['Exploring', 'Soon', 'Active Priority', 'Urgent'], id: ['Baru Mengeksplorasi', 'Segera', 'Prioritas Aktif', 'Urgen'] }, required: true },
      more: { label: { en: 'Anything else we should understand?', id: 'Ada hal lain yang perlu kami pahami?' }, placeholder: { en: 'Optional…', id: 'Opsional…' } },
    },
  },

  received: {
    headline: {
      en: 'Your context has been received.',
      id: 'Konteks Anda telah kami terima.',
    },
    body1: { en: 'Thank you for reaching out to Navartha.', id: 'Terima kasih telah menghubungi Navartha.' },
    body2: {
      en: "We'll review the information you shared to understand whether there is a real opportunity for a Business Clinic conversation.",
      id: 'Kami akan meninjau informasi yang Anda bagikan untuk memahami apakah ada peluang nyata untuk percakapan Business Clinic.',
    },
    body3: {
      en: "If there is a fit, we'll contact you using the email provided.",
      id: 'Jika ada kesesuaian, kami akan menghubungi Anda melalui email yang Anda berikan.',
    },
    flow: {
      en: ['Review', 'Qualification', 'Business Clinic invitation, if appropriate'],
      id: ['Tinjau', 'Kualifikasi', 'Undangan Business Clinic, jika sesuai'],
    },
    cta: { en: 'Return to Navartha', id: 'Kembali ke Navartha' },
  },

  privacy: {
    title: { en: 'Privacy & Data Handling', id: 'Privasi & Penanganan Data' },
    intro: {
      en: 'Navartha collects only the information reasonably needed to review Business Clinic submissions, communicate with prospective clients, and operate the Business Clinic process.',
      id: 'Navartha hanya mengumpulkan informasi yang wajar dan diperlukan untuk meninjau permintaan Business Clinic, berkomunikasi dengan calon klien, dan menjalankan proses Business Clinic.',
    },
    sections: {
      en: [
        { title: 'Information you may provide', body: 'When you submit a Business Clinic request, you may share your name, work email, role, company details, and a description of your business situation. Please only share what is appropriate for an initial review.' },
        { title: 'Please do not submit sensitive information', body: 'Please do not submit passwords, API keys, login credentials, confidential files, sensitive personal information, or production data through this form. General business and workflow information is sufficient for the initial Business Clinic review.' },
        { title: 'How information is used', body: 'We use the information to review your submission, assess whether there may be a real opportunity, and, if there is a fit, contact you using the email provided. We do not use it for anything else at this stage.' },
        { title: 'Sharing', body: 'We do not sell your information. We do not share it with third parties, except where necessary to operate our basic systems or where required by law.' },
        { title: 'Security', body: 'Submissions are stored with restricted access inside our platform database. No system is perfectly secure, which is why we ask you to avoid sending sensitive information through this form.' },
        { title: 'Contact', body: 'For questions about this policy or your information: hello@navartha.id' },
      ],
      id: [
        { title: 'Informasi yang dapat Anda kirimkan', body: 'Saat Anda mengirim permintaan Business Clinic, Anda dapat membagikan nama, email kerja, jabatan, detail perusahaan, dan gambaran singkat tentang situasi bisnis Anda. Mohon hanya membagikan informasi yang sesuai untuk tinjauan awal.' },
        { title: 'Mohon jangan kirim informasi sensitif', body: 'Mohon jangan kirim kata sandi, API key, kredensial login, file rahasia, data pribadi sensitif, atau data produksi melalui formulir ini. Informasi bisnis dan alur kerja umum sudah cukup untuk tinjauan awal Business Clinic.' },
        { title: 'Bagaimana informasi digunakan', body: 'Kami menggunakan informasi tersebut untuk meninjau kiriman Anda, menilai apakah ada peluang nyata, dan, jika ada kesesuaian, menghubungi Anda melalui email yang diberikan. Pada tahap ini, kami tidak menggunakannya untuk hal lain.' },
        { title: 'Pembagian informasi', body: 'Kami tidak menjual informasi Anda dan tidak membagikannya kepada pihak ketiga, kecuali jika diperlukan untuk menjalankan sistem dasar kami atau diwajibkan oleh hukum.' },
        { title: 'Keamanan', body: 'Kiriman disimpan dengan akses terbatas di dalam basis data platform kami. Tidak ada sistem yang sepenuhnya aman, karena itu mohon hindari mengirim informasi sensitif melalui formulir ini.' },
        { title: 'Kontak', body: 'Untuk pertanyaan seputar kebijakan ini atau informasi Anda: hello@navartha.id' },
      ],
    },
  },

  meta: {
    home: {
      title: { en: 'Navartha — AI Transformation & Implementation', id: 'Navartha — AI Transformation & Implementation' },
      desc: {
        en: 'Navartha helps companies identify high-value problems, redesign workflows, and implement the right AI and technology for measurable business outcomes.',
        id: 'Navartha membantu perusahaan mengidentifikasi masalah bernilai tinggi, merancang ulang alur kerja, dan mengimplementasikan AI serta teknologi yang tepat untuk hasil bisnis yang terukur.',
      },
    },
    clinic: {
      title: { en: 'Business Clinic — Navartha', id: 'Business Clinic — Navartha' },
      desc: {
        en: 'Start with the problem, not the tool. The Navartha Business Clinic is an initial conversation to understand where change could create real value in your business.',
        id: 'Mulai dari masalah, bukan tool. Business Clinic dari Navartha adalah percakapan awal untuk memahami di mana perubahan dapat menciptakan nilai di bisnis Anda.',
      },
    },
    privacy: {
      title: { en: 'Privacy & Data Handling — Navartha', id: 'Privasi & Penanganan Data — Navartha' },
      desc: {
        en: 'How Navartha handles information submitted through the Business Clinic process.',
        id: 'Bagaimana Navartha menangani informasi yang dikirim melalui proses Business Clinic.',
      },
    },
    received: {
      title: { en: 'Received — Business Clinic — Navartha', id: 'Diterima — Business Clinic — Navartha' },
      desc: {
        en: 'Your Business Clinic context has been received by Navartha.',
        id: 'Konteks Business Clinic Anda telah diterima oleh Navartha.',
      },
    },
  },
};
